function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppkeyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 1024 1024",
    enableBackground: "new 0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-0",
    d: "M 1050.414 421.211 C 1025.91 438.013 1010 451.786 995.447 469.519 C 982.891 495.067 982.947 514.952 984.109 537.46 C 991.775 566.393 1001.045 586.106 1012.554 605.593 C 1043.617 649.478 1085.736 663.942 1129.926 676.533 C 1182.533 684.33 1220.83 688.734 1255.15 672.321 C 1281.218 638.763 1290.117 608.128 1297.82 572.502 C 1304.395 525.818 1302.771 488.789 1301.55 452.962 C 1296.579 426.85 1279.756 420.746 1260.437 417.339 C 1237.96 415.905 1220.732 416.592 1202.064 419.246 C 1182.923 420.81 1168.95 419.302 1155.235 420.904 L 1153.614 420.978 C 1152.075 421.108 1150.571 421.333 1149.041 421.519",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "520.904px 515.234px"
    },
    transform: "matrix(0, 0.975196, 0.975196, 0, -16.975378, -10.011192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 589.635 722.134 C 594.15 722.134 597.885 725.463 598.522 729.801 L 615.269 729.801 C 615.906 725.463 619.641 722.134 624.156 722.134 C 628.67 722.134 632.406 725.463 633.043 729.801 L 649.41 729.801 C 650.205 725.653 653.852 722.519 658.232 722.519 C 662.612 722.519 666.259 725.653 667.054 729.801 L 691.757 729.801 L 691.757 780.498 L 558.729 780.498 L 558.729 729.801 L 580.748 729.801 C 581.385 725.463 585.121 722.134 589.635 722.134 Z",
    style: {
      fill: "rgb(70, 56, 171)",
      stroke: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589.48 803.709 C 593.995 803.709 597.73 807.038 598.367 811.375 L 615.114 811.375 C 615.751 807.038 619.486 803.709 624.001 803.709 C 628.515 803.709 632.251 807.038 632.888 811.375 L 649.255 811.375 C 650.05 807.228 653.697 804.094 658.077 804.094 C 662.457 804.094 666.104 807.228 666.899 811.375 L 691.602 811.375 L 691.602 862.073 L 558.574 862.073 L 558.574 811.375 L 580.593 811.375 C 581.23 807.038 584.966 803.709 589.48 803.709 Z",
    style: {
      fill: "rgb(70, 56, 171)",
      stroke: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589.635 886.463 C 594.15 886.463 597.885 889.791 598.522 894.129 L 615.269 894.129 C 615.906 889.791 619.641 886.463 624.156 886.463 C 628.67 886.463 632.406 889.791 633.043 894.129 L 649.41 894.129 C 650.205 889.981 653.852 886.848 658.232 886.848 C 662.612 886.848 666.259 889.981 667.054 894.129 L 691.757 894.129 L 691.757 944.827 L 558.729 944.827 L 558.729 894.129 L 580.748 894.129 C 581.385 889.791 585.121 886.463 589.635 886.463 Z",
    style: {
      fill: "rgb(70, 56, 171)",
      stroke: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.153297, 0, 0, 15.153297, 339.084869, 60.680202)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5H9.5V9.5H5V5ZM6.5 6.5V8H8V6.5H6.5Z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4999 5H18.9999V9.5H14.4999V5ZM15.9999 6.5V8H17.4999V6.5H15.9999Z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14.5H9.5V19H5V14.5ZM6.5 16V17.5H8V16H6.5Z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11.25,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.25,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1666,
    y: 11.25,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1666,
    y: 14.375,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1666,
    y: 17.5,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1666,
    y: 8.125,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1666,
    y: 5,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3333,
    y: 11.25,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.4999,
    y: 11.25,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3333,
    y: 14.375,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.4999,
    y: 14.375,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3333,
    y: 17.5,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.4999,
    y: 17.5,
    width: 1.5,
    height: 1.5,
    style: {
      fill: "rgb(70, 56, 171)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 517.643 993.496 C 506.567 993.496 495.729 992.468 485.224 990.501 L 485.224 646.267 C 485.268 646.259 485.313 646.25 485.358 646.242 L 485.358 454.716 L 557.785 454.716 L 557.785 984.862 L 557.377 984.862 L 557.377 988.969 C 544.611 991.93 531.31 993.496 517.643 993.496 Z",
    style: {
      stroke: "rgb(70, 56, 171)",
      fillRule: "nonzero",
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 693.791 247.715 C 693.791 343.198 616.387 420.602 520.904 420.602 C 425.421 420.602 348.017 343.198 348.017 247.715 C 348.017 152.232 425.421 74.828 520.904 74.828 C 616.387 74.828 693.791 152.232 693.791 247.715 Z M 520.904 36.973 C 404.514 36.973 310.162 131.325 310.162 247.715 C 310.162 364.105 404.514 458.457 520.904 458.457 C 637.294 458.457 731.646 364.105 731.646 247.715 C 731.646 131.325 637.294 36.973 520.904 36.973 Z",
    style: {
      stroke: "rgb(70, 56, 171)",
      fill: "rgb(70, 56, 171)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 485.164 314.086 C 483.477 314.929 481.038 317.274 479.819 319.431 C 477.192 323.934 447.93 398.123 446.429 403.938 C 445.585 407.221 445.678 408.44 446.992 410.972 C 449.056 415.005 454.026 417.068 458.34 415.662 C 462.092 414.443 462.466 413.694 467.627 400.656 L 471.565 390.807 L 492.012 390.807 L 512.458 390.807 L 516.585 401.125 C 521.368 413.036 523.807 416.038 528.497 416.038 C 534.78 416.038 538.814 412.097 538.626 406.189 C 538.533 403 507.862 325.809 504.205 319.431 C 500.452 312.96 492.105 310.615 485.164 314.086 Z M 499.703 355.167 C 503.454 365.483 506.549 374.207 506.549 374.581 C 506.549 374.956 499.89 375.332 491.636 375.332 L 476.818 375.332 L 483.195 357.23 C 491.45 334.251 491.824 333.407 492.386 335.094 C 492.575 335.845 495.857 344.85 499.703 355.167 Z",
    style: {
      fill: "rgb(70, 56, 171)"
    },
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 734.276 315.211 L 731.181 317.931 L 730.899 363.326 C 730.712 406.939 730.712 408.722 732.493 411.628 C 734.932 415.568 740.559 417.444 744.312 415.568 C 749.846 412.848 750.69 410.41 751.253 395.778 L 751.816 382.366 L 759.6 374.956 C 766.259 368.484 767.478 367.641 768.604 368.86 C 769.26 369.61 775.639 379.271 782.767 390.338 C 789.895 401.406 796.554 411.442 797.585 412.662 C 800.211 415.568 805.37 416.788 809.778 415.568 C 815.687 413.973 817.562 408.909 814.749 402.157 C 813.998 400.374 806.683 389.306 798.524 377.489 C 790.27 365.765 783.235 355.542 782.767 354.791 C 782.204 353.759 785.768 349.82 796.085 339.785 C 811.279 325.058 812.499 323.09 809.967 317.743 C 807.434 312.492 801.243 310.991 795.897 314.272 C 794.397 315.211 783.799 325.716 772.448 337.627 L 751.816 359.387 L 751.346 339.879 C 750.784 318.964 750.126 315.962 745.719 313.71 C 741.685 311.647 737.653 312.209 734.276 315.211 Z",
    style: {
      fill: "rgb(70, 56, 171)"
    },
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 556.071 341.942 C 552.696 344.474 552.507 347.663 552.507 392.496 C 552.507 432.732 552.696 437.047 554.196 440.049 C 555.602 442.956 556.26 443.331 559.823 443.612 C 565.076 443.987 568.077 442.017 569.296 437.516 C 569.858 435.546 570.327 427.292 570.327 419.038 L 570.327 404.126 L 575.018 408.533 C 581.395 414.537 585.241 416.038 593.776 416.038 C 609.626 416.038 620.601 406.096 624.352 388.556 C 629.699 363.045 617.037 342.129 595.558 340.816 C 589.274 340.441 587.679 340.722 583.178 342.785 C 580.363 344.006 576.424 346.631 574.361 348.507 L 570.516 351.883 L 569.484 347.756 C 568.922 345.319 567.514 342.88 566.389 342.129 C 563.857 340.347 558.228 340.254 556.071 341.942 Z M 596.683 356.198 C 609.907 362.858 610.189 391.651 597.245 399.812 C 594.901 401.311 593.025 401.594 588.523 401.406 C 581.584 401.031 577.081 398.03 573.892 391.933 C 571.452 387.055 570.516 375.519 572.11 369.048 C 575.205 356.948 586.459 351.04 596.683 356.198 Z",
    style: {
      fill: "rgb(70, 56, 171)"
    },
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 644.235 341.942 C 640.86 344.474 640.671 347.663 640.671 392.496 C 640.671 432.732 640.86 437.047 642.36 440.049 C 643.766 442.956 644.424 443.331 647.988 443.612 C 653.24 443.987 656.241 442.017 657.46 437.516 C 658.022 435.546 658.491 427.292 658.491 419.038 L 658.491 404.126 L 663.183 408.533 C 669.559 414.537 673.405 416.038 681.94 416.038 C 697.79 416.038 708.765 406.096 712.517 388.556 C 717.862 363.045 705.201 342.129 683.722 340.816 C 677.439 340.441 675.844 340.722 671.342 342.785 C 668.527 344.006 664.588 346.631 662.525 348.507 L 658.68 351.883 L 657.648 347.756 C 657.086 345.319 655.678 342.88 654.553 342.129 C 652.021 340.347 646.394 340.254 644.235 341.942 Z M 684.847 356.198 C 698.073 362.858 698.354 391.651 685.411 399.812 C 683.065 401.311 681.189 401.594 676.688 401.406 C 669.748 401.031 665.246 398.03 662.056 391.933 C 659.618 387.055 658.68 375.519 660.274 369.048 C 663.369 356.948 674.624 351.04 684.847 356.198 Z",
    style: {
      fill: "rgb(70, 56, 171)"
    },
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 847.295 342.445 C 832.383 347.604 824.503 360.172 824.503 378.648 C 824.503 390.28 827.973 399.47 834.914 406.411 C 848.046 419.542 876.371 419.448 889.126 406.318 C 894.941 400.315 895.504 393.28 890.345 391.499 C 886.97 390.373 884.343 391.404 878.808 396.375 C 876.371 398.627 872.713 401.16 870.743 402.097 C 866.242 404.255 857.893 404.348 853.861 402.285 C 849.734 400.128 845.513 394.594 844.294 389.81 C 842.419 382.308 840.823 382.87 863.99 382.87 C 893.535 382.87 895.41 382.026 894.661 369.551 C 894.004 357.827 888.001 349.011 877.214 343.758 C 872.525 341.508 870.649 341.132 862.02 340.944 C 854.423 340.757 851.047 341.132 847.295 342.445 Z M 867.273 354.639 C 872.713 357.077 877.027 364.112 877.027 370.302 L 877.027 372.552 L 860.051 372.552 L 843.075 372.552 L 843.73 369.081 C 846.076 356.326 856.675 349.855 867.273 354.639 Z",
    style: {
      fill: "rgb(70, 56, 171)"
    },
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 904.132 343.349 C 902.445 345.131 901.413 347.101 901.413 348.788 C 901.413 350.289 907.041 365.672 913.982 383.116 L 926.549 414.724 L 923.454 421.195 C 921.672 424.759 919.422 428.136 918.39 428.7 C 917.358 429.262 913.418 429.73 909.572 429.73 C 901.226 429.73 899.255 431.138 899.725 436.952 C 900.101 442.017 903.946 443.8 914.45 443.8 C 924.673 443.8 928.893 442.486 933.771 437.516 C 938.367 432.919 939.305 430.95 954.593 390.807 C 971.663 346.162 971.475 346.818 967.537 342.88 C 965.661 341.004 964.442 340.535 961.251 340.816 C 957.97 341.004 956.938 341.661 955.249 344.099 C 954.217 345.693 949.81 357.042 945.496 369.423 C 941.181 381.71 937.335 392.776 936.773 394.091 C 936.022 396.154 934.896 393.434 928.519 374.863 C 918.577 345.786 918.295 345.224 915.858 342.785 C 912.667 339.597 907.696 339.879 904.132 343.349 Z",
    style: {
      fill: "rgb(70, 56, 171)"
    },
    fill: "#000000",
    stroke: "none"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppkeyLogo);
export default __webpack_public_path__ + "static/media/appkey_logo.9c09ff5bd314e66a33b7d808de0f563e.svg";
export { ForwardRef as ReactComponent };